function Tab(props: any) {
    const { index, isActive, text, parentOnClick } = props;
    const buttonClass = isActive ? "active-tab tab" : "tab";
    const onClick = () => {
        parentOnClick(index)
    }
    return (
        <button 
            className={buttonClass}
            onClick={onClick}
        >
            {text}
        </button>
    )
}

export default Tab